import Welton91 from '../../../Media/BSD/Hiera/Welton 9.webp'
import Welton92 from '../../../Media/BSD/Hiera/Welton 9.webp'





const Welton9images =[
Welton91,Welton92
]

export default Welton9images;